import React from 'react';
import { TICKER_STATS } from '../data';

export default function NumbersTicker() {
  const repeated = [...TICKER_STATS, ...TICKER_STATS, ...TICKER_STATS];
  return (
    <div style={{
      borderTop: '1px solid rgba(255,255,255,0.07)',
      borderBottom: '1px solid rgba(255,255,255,0.07)',
      padding: '14px 0', overflow: 'hidden',
      // Fixed dark — does not shift with mood variables
      background: '#1a1a1a', position: 'relative',
    }}>
      <div style={{
        display: 'flex', gap: '0',
        animation: 'ticker 40s linear infinite',
        width: 'max-content',
      }}>
        {repeated.map((stat, i) => (
          <React.Fragment key={i}>
            <span style={{
              fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.12em',
              color: 'rgba(250,250,248,0.7)', whiteSpace: 'nowrap', padding: '0 32px',
              textTransform: 'uppercase',
            }}>{stat}</span>
            <span style={{ color: '#e8c547', opacity: 0.6, fontSize: '10px', alignSelf: 'center' }}>·</span>
          </React.Fragment>
        ))}
      </div>
      <style>{`
        @keyframes ticker {
          from { transform: translateX(0); }
          to { transform: translateX(-33.333%); }
        }
      `}</style>
    </div>
  );
}
